module.exports = __webpack_public_path__ + "img/credit-one.c95fd369.svg";